import React, { useEffect, useState } from 'react';

import { useNavigate } from 'react-router-dom';

import { Alert, Box, Button, CircularProgress, Container, Dialog, DialogActions, DialogContent, FormControl, Grid, IconButton, InputLabel, LinearProgress, MenuItem, Paper, Select, Switch, Table, TableBody, TableCell, TableContainer, TableFooter, TableHead, TablePagination, 
  TableRow, TextField, Toolbar, Typography 
} from '@mui/material';

import AddCircleOutlineRoundedIcon from '@mui/icons-material/AddCircleOutlineRounded';
import EditIcon from '@mui/icons-material/Edit';
import SaveIcon from '@mui/icons-material/Save';
import UndoIcon from '@mui/icons-material/Undo';

import { NavbarInicio } from '../ui/NavbarInicio';

import { usePages } from '../../hooks/usePages';

import { TablePaginationActions } from '../../helpers/TablePaginationActions';

import { ActualizarCiudad, AgregarCiudad, Ciudades } from '../../actions/catalogos/ciudadActions';
import { ObtenerEstados } from '../../actions/catalogos/estadoActions';
import { ObtenerMunicipios } from '../../actions/catalogos/municipioActions';

import { usePermisos } from '../../hooks/usePermisos';

import { NotFoundScreen } from '../auth/NotFoundScreen';
    
export const CiudadScreen = ( ) => {

    const { tipoUsuario, loading } = usePermisos();

    const navigate = useNavigate();

    const [errors, setErrors] = useState({ });

    const [rows, setRows] = useState( [ ] );

    const [estado, setEstado] = useState( 0 );
    const [estadoArray, setEstadoArray] = useState( [ ] );

    const [municipio, setMunicipio] = useState( 0 );
    const [municipioArray, setMunicipioArray] = useState( [ ] );

    const [descripcion, setDescripcion] = useState( '' );
    const [idReferencia, setIdReferencia] = useState( '' );
    const [opcion, setOpcion] = useState( '' );

    const [loadingTable, setLoadingTable] = useState( true );
    const [loadingSave, setLoadingSave] = useState( false );
    const [openModal, setOpenModal] = useState( false );
  
    const [page, rowsPerPage, handleChangePage, handleChangeRowsPerPage] = usePages();
  
    const handleChangeSwitch = ( id, value ) => {

        const newRows = rows.map( (row) => { if(row.idCiudad === id){ row.activo = value; return row; } else{ return row; } } );
        setRows( newRows );        

        const ciudad = rows.filter( function(row){ return row.idCiudad === id; } );
        cambiarEstatus( ciudad[0] );
    }

    const handleOpenModal = () => {
        setOpenModal(true);
    }

    const handleCloseModal = () => {
        setOpenModal(false);
        setErrors( { } );
    }

    const cambiarEstatus = async ( { idCiudad, clave, descripcion, activo, estado, municipio } ) => {

        const params = {
            idCiudad,
            clave,
            idEstado: estado.idEstado,
            idMunicipio: municipio.idMunicipio,
            descripcion,
            activo,
        };

        await ActualizarCiudad( params );
    }

    const AgregarRegistro = () => {

        setEstado( 0 );
        setMunicipio( 0 );
        setDescripcion( '' );

        setOpcion( 'agregar' );
        setIdReferencia( 0 );

        handleOpenModal();
    }

    const EditarRegistro = ( id, descripcion, idEstado, idMunicipio ) => {
        
        setDescripcion( descripcion );
        setEstado( idEstado );

        setOpcion( 'editar' );
        setIdReferencia( id );

        asyncMunicipiosEdit( idEstado, idMunicipio );

        handleOpenModal();
    }

    const Guardar = async () => {

        const valid = validateFiels();

        if( !valid ){
            return false;
        }

        setLoadingSave( true );

        if( opcion === 'agregar' ){
            const params = {
                idCiudad: 0,
                clave: '',
                descripcion: descripcion.trim(),
                idEstado: estado,
                idMunicipio: municipio,
                activo: true,
            };

            await AgregarCiudad( params ).then( response => {
                if( response ){
                    if( response.status === 200){
                        if( response.data ){

                            setTimeout(() => {
                                
                                setRows([ 
                                    ...rows,  
                                    {
                                        idCiudad: response.data.idCiudad,
                                        idEstado: response.data.idEstado,
                                        idMunicipio: response.data.idMunicipio,
                                        estado: response.data.estado,
                                        municipio: response.data.municipio,
                                        clave: response.data.clave,
                                        descripcion: descripcion,
                                        activo: true
                                    }
                                ]);  

                                handleCloseModal();

                                setLoadingSave( false );

                            }, 1000);
                        } 
                    }
                }
            });
        }

        if( opcion === 'editar' ){
            const ciudad = rows.filter( function(row){ return row.idCiudad === idReferencia; } )[0];

            const params = {
                idCiudad: idReferencia,
                idEstado: estado,
                idMunicipio: municipio,
                descripcion: descripcion.trim(),                
                activo: ciudad.activo,
                clave: ciudad.clave,
            };
    
            await ActualizarCiudad( params ).then( response => {
                if( response ){
                    if( response.status === 200){
                        
                        setTimeout(() => {
                            
                            const newRows = rows.map( (row) => { 
                                if(row.idCiudad === idReferencia){ 
                                    row.clave = response.data.clave; 
                                    row.descripcion = descripcion; 
                                    row.estado = response.data.estado;
                                    row.municipio = response.data.municipio;
                                    return row; 
                                } 
                                else{ 
                                    return row; 
                                } 
                            });

                            setRows( newRows ); 
                            
                            handleCloseModal();

                            setLoadingSave( false );

                        }, 1000);
                    }
                }                
            });
        }
    }

    const validateFiels = () => {
        
        setErrors( { } );

        let valid = true;
        let errores = {};

        if( descripcion.trim() === '' ){
            valid = false;
            errores.descripcion = 'Debes escribir la descripción';
        }        

        if( estado === 0 ){
            valid = false;
            errores.estado = 'Debes seleccionar un estado';
        }  

        if( estado !== 0 && municipio === 0 ){
            valid = false;
            errores.municipio = 'Debes seleccionar un municipio';
        }  
        
        setErrors( errores );
        return valid;
    } 

    const asyncMunicipiosEdit = async (idEstado, idMunicipio) => {
        
        await ObtenerMunicipios( idEstado ).then( response => {
            if(response){
                if( response.status === 200){
                    setMunicipioArray( response.data );  
                    
                    setMunicipio( idMunicipio );
                }
            }
        });

    }

    useEffect(() => {
        
        async function Obtener(){
            
            await Ciudades().then(response => {
                
                if( response ){
                    if( response.status === 200 ){

                        setTimeout(() => {
                            
                            setLoadingTable( false );
                            setRows( response.data );

                        }, 1000);
                        
                    }
                }
                
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){
            
            await ObtenerEstados().then(response => {
                
                if( response ){
                    if( response.status === 200 ){
                        setEstadoArray( response.data );
                    }
                }
                
            });

        }

        Obtener();

    }, [ ]);

    useEffect(() => {
        
        async function Obtener(){     

            setMunicipio( 0 );

            if( estado !== 0 ){       
                await ObtenerMunicipios( estado ).then( response => {
                    if(response){
                        if( response.status === 200){
                            setMunicipioArray( response.data );   
                        }
                    }
                });
            }

        }

        Obtener();

    }, [ estado ]);

    return (
        <>
            <NavbarInicio />

            {
                ( !loading && tipoUsuario !== 3 )
                &&
                <NotFoundScreen />
            }

            {
                ( !loading && tipoUsuario === 3  )
                &&   
                <>

                    <Container maxWidth='xl' sx={{ mt: { md: '13em', xs: '11em' } }}>

                        <Box sx={{ pb: '2em', pl: { md: 10, xs: 1 }, pr: { md: 10, xs: 1 }, pt: 2 }} component={ Paper } >	

                            <Container maxWidth="lg">   

                                <Grid container spacing={3} sx={{ mt: 1 }} >  
                                        
                                    <Grid item md={6} xs={6} sx={{ textAlign: 'left' }}> 
                                        <Button type="button" startIcon={ <UndoIcon /> } variant='contained' color='inherit' sx={{ mt: 1 }} onClick={ () => navigate('/administracion/') }> 
                                            Regresar a los catálogos
                                        </Button> 
                                    </Grid>

                                    <Grid item md={6} xs={6} sx={{ textAlign: 'right' }}> 
                                        <Button type="button" startIcon={ <AddCircleOutlineRoundedIcon /> } variant="contained" sx={{ mt: 1 }} onClick={ AgregarRegistro }> 
                                            Agregar
                                        </Button> 
                                    </Grid>

                                </Grid>

                                <Grid container spacing={3} sx={{ mt: 1 }} >  
                                    
                                    <Grid item xs={12} md={12}>                                     

                                        <Toolbar sx={{ pl: { sm: 2 }, pr: { xs: 1, sm: 1 } }} >
                                            <Typography sx={{ flex: '1 1 100%' }} variant="h6" component="div" >
                                                Ciudad
                                            </Typography>
                                        </Toolbar>

                                        <TableContainer>

                                            <Table sx={{ minWidth: 500 }} >
                                                <TableHead>
                                                    <TableRow>        
                                                        <TableCell style={{ width:'10%' }}> ID </TableCell>
                                                        <TableCell style={{ width:'10%' }}> CLAVE </TableCell>
                                                        <TableCell style={{ width:'20%' }}> DESCRIPCIÓN </TableCell>
                                                        <TableCell style={{ width:'20%' }}> MUNICIPIO </TableCell>
                                                        <TableCell style={{ width:'20%' }}> ESTADO </TableCell>
                                                        <TableCell style={{ width:'10%' }}> HABILITADO </TableCell>
                                                        <TableCell style={{ width:'10%' }}> EDITAR </TableCell>
                                                    </TableRow>
                                                </TableHead>

                                                <TableBody>
                                                {
                                                (rowsPerPage > 0
                                                    ? rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage)
                                                    : rows
                                                ).map((row) => (
                                                    <TableRow key={ row.idCiudad} >
                                                    
                                                        <TableCell style={{ fontWeight: 'bold' }}>
                                                            { row.idCiudad }
                                                        </TableCell>

                                                        <TableCell>
                                                            { row.clave }
                                                        </TableCell>

                                                        <TableCell>
                                                            { row.descripcion }
                                                        </TableCell>

                                                        <TableCell>
                                                            { row.municipio.descripcion }
                                                        </TableCell>

                                                        <TableCell>
                                                            { row.estado.descripcion }
                                                        </TableCell>
                                                        
                                                        <TableCell>
                                                            {
                                                                row.activo 
                                                                ? 
                                                                (
                                                                    <Switch 
                                                                        inputProps={ { 'aria-label': 'Switch demo'} } 
                                                                        checked={ row.activo } 
                                                                        onChange={ ( e ) => handleChangeSwitch( row.idCiudad, e.target.checked ) }
                                                                    />
                                                                ) 
                                                                :                                           
                                                                ( 
                                                                    <Switch 
                                                                        inputProps={ { 'aria-label': 'Switch demo'} } 
                                                                        checked={ row.activo } 
                                                                        onChange={ ( e ) => handleChangeSwitch( row.idCiudad, e.target.checked ) }
                                                                    />
                                                                )
                                                            }
                                                        </TableCell>

                                                        <TableCell>
                                                            <IconButton 
                                                                    color="primary" 
                                                                    aria-label="edit" 
                                                                    component="span" 
                                                                    onClick={ () => EditarRegistro( row.idCiudad, row.descripcion, row.estado.idEstado, row.municipio.idMunicipio ) }
                                                                >                                                        
                                                                <EditIcon />
                                                            </IconButton>  
                                                        </TableCell>

                                                    </TableRow>
                                                ))}

                                                
                                                { 
                                                    rows.length === 0 && (
                                                        <TableRow style={{ height: 53 }}>

                                                            <TableCell colSpan={10} align="center"> 
                                                                {
                                                                    loadingTable
                                                                    ?
                                                                        <CircularProgress size={40} sx={{ mt: 2, mb: 2 }} />
                                                                    :
                                                                        ''
                                                                }
                                                                {
                                                                    !loadingTable && rows.length === 0
                                                                    ?
                                                                        'No se encontraron usuarios'
                                                                    :
                                                                        ''
                                                                }
                                                            </TableCell>

                                                        </TableRow>
                                                    )
                                                }


                                                </TableBody>

                                                <TableFooter>
                                                    <TableRow>
                                                        <TablePagination
                                                            rowsPerPageOptions={[ 5, 10, 15, 20, 25, 50, 100 ]}
                                                            colSpan={7}
                                                            count={rows.length}                                        
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}                                                                                
                                                            onPageChange={ handleChangePage }
                                                            onRowsPerPageChange={ handleChangeRowsPerPage }
                                                            ActionsComponent={ TablePaginationActions }

                                                            labelRowsPerPage="Filas por página"                                            
                                                            labelDisplayedRows={
                                                                ({ from, to, count }) => {
                                                                return '' + from + '-' + to + ' de ' + count
                                                                }
                                                            }  
                                                        />
                                                    </TableRow>
                                                </TableFooter>
                                            </Table>
                                        </TableContainer> 

                                    </Grid>

                                </Grid>

                            </Container>

                        </Box>

                        <Dialog open={ openModal } maxWidth='sm' fullWidth={true}>       
                        
                            <DialogContent>
                                
                                <FormControl fullWidth sx={{ mt: 3 }} >
                                    <InputLabel id="select-estado-label">Estado</InputLabel>
                                
                                    <Select
                                        labelId="select-estado-label"
                                        id="select-estado"                                            
                                        label="Estado"
                                        name="estado"
                                        value={ estado }                                
                                        onChange={ ( e ) => { setEstado( e.target.value ) } }
                                    >
                                        <MenuItem key={0} value={0}>Seleccione una opción</MenuItem>
                                        {
                                            estadoArray.map( ( elem ) => (
                                                <MenuItem key={ elem.idEstado } value={ elem.idEstado }> { elem.descripcion } </MenuItem>
                                            ))
                                        }
                                    </Select>

                                </FormControl>

                                {   
                                    errors.estado && ( <Alert color='warning' severity="warning" variant="filled" style={{ marginTop: '1em' }} > { errors.estado } </Alert> )
                                }

                                <FormControl fullWidth sx={{ mt: 3 }} >
                                    <InputLabel id="select-municipio-label">Municipio</InputLabel>
                                
                                    <Select
                                        labelId="select-municipio-label"
                                        id="select-municipio"                                            
                                        label="Municipio"
                                        name="municipio"
                                        value={ municipio }                                
                                        onChange={ ( e ) => { setMunicipio( e.target.value ) } }
                                        disabled={ estado === 0 }
                                    >
                                        <MenuItem key={0} value={0}>Seleccione una opción</MenuItem>
                                        {
                                            municipioArray.map( ( elem ) => (
                                                <MenuItem key={ elem.idMunicipio } value={ elem.idMunicipio }> { elem.descripcion } </MenuItem>
                                            ))
                                        }
                                    </Select>

                                </FormControl>

                                {   
                                    errors.municipio && ( <Alert color='warning' severity="warning" variant="filled" style={{ marginTop: '1em' }} > { errors.municipio } </Alert> )
                                }

                                <TextField
                                    sx={{ mt: 3 }}
                                    label='Descripción'
                                    variant="outlined"                           
                                    multiline
                                    rows={4}                                        
                                    fullWidth
                                    value={ descripcion }
                                    onChange={ ( e ) => { setDescripcion( e.target.value ) } }
                                />

                                {   
                                    errors.descripcion && ( <Alert color='warning' severity="warning" variant="filled" style={{ marginTop: '1em' }} > { errors.descripcion } </Alert> )
                                }

                            </DialogContent>

                            <DialogActions>
                                <Button onClick={ handleCloseModal }> Cancelar </Button>
                                <Button onClick={ Guardar } variant='contained' startIcon={ <SaveIcon /> } > Guardar </Button>
                            </DialogActions>

                            <LinearProgress sx={{ display: loadingSave ? 'flex' : 'none' }} />

                        </Dialog>

                    </Container>
                </>
            }
        </>
    )
}
